// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE file in the project root for full license information.
'use strict';
/* tslint:disable:variable-name */
/**
 * @private
 */
var DefaultErrorFilter = (function () {
    function DefaultErrorFilter() {
        this.ArgumentError = false;
        this.ArgumentOutOfRangeError = false;
        this.DeviceMaximumQueueDepthExceededError = false; // ??
        this.DeviceNotFoundError = false;
        this.FormatError = false;
        this.UnauthorizedError = false;
        this.NotImplementedError = false;
        this.NotConnectedError = true;
        this.IotHubQuotaExceededError = false;
        this.MessageTooLargeError = false;
        this.InternalServerError = true;
        this.ServiceUnavailableError = true;
        this.IotHubNotFoundError = false;
        this.IoTHubSuspendedError = false; // ??
        this.JobNotFoundError = false;
        this.TooManyDevicesError = false;
        this.ThrottlingError = true;
        this.DeviceAlreadyExistsError = false;
        this.DeviceMessageLockLostError = false;
        this.InvalidEtagError = false;
        this.InvalidOperationError = false;
        this.PreconditionFailedError = false; // ??
        this.TimeoutError = true;
        this.BadDeviceResponseError = false;
        this.GatewayTimeoutError = false; // ??
        this.DeviceTimeoutError = false; // ??
    }
    return DefaultErrorFilter;
}());
exports.DefaultErrorFilter = DefaultErrorFilter;
/* tslint:enable:variable-name */
//# sourceMappingURL=retry_error_filter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/azure-iot-common/lib/retry_error_filter.js
// module id = 346
// module chunks = 0